import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, combineLatest, Observable, forkJoin } from 'rxjs';
import { takeUntil, filter as rxFilter, take } from 'rxjs/operators';
import { FILTER_TYPES, IFilterData } from 'src/app/core/feature-modules/table-filter/table-filter.interfaces';
import { SYSTEM_COLORS } from 'src/app/core/feature-modules/whitelabel/style-changer/styles/colors/system-colors.constants';
import {
  IReviewsMetrics,
  IFitersObject,
  PeriodType,
  PeriodText,
} from '../review-management.interfaces';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { generateJWTToken } from 'src/app/core/helpers/jwt-token.utils';
import { SessionService } from 'src/app/core/backend-adapter/session.service';
import { IAccount } from 'src/app/acct-comps/accounts.interfaces';
import { ConvertCSVToJSONService } from 'src/app/reports/shared/services/convert-csv-to-json.service';

@Component({
  selector: 'app-metrics-tab',
  templateUrl: './metrics-tab.component.html',
  styleUrls: ['./metrics-tab.component.scss'],
})
export class MetricsTabComponent implements OnInit, OnDestroy {
  showOverview = true;
  reviewsData: IReviewsMetrics;
  dailyAvgRatings: any;
  dailyTotalReviews: any;
  periodType:string;
  SYSTEM_COLORS = SYSTEM_COLORS;
  keyword = '';
  filterData: IFilterData[] = [];
  chipsArray: string[] = [];
  filters: IFitersObject= {};
  /*private selectedDateRange = 'DefaultDate';*/

  private ngUnsubscribe$ = new Subject<void>();
  private accountId: number;
  private userId: number;
  private defaultPeriodType: PeriodType = PeriodType.DAY;

  constructor(
    private http: HttpClient,
    public sessionService: SessionService,
    private convertCSVToJSONService: ConvertCSVToJSONService,
    
  ) {this.periodType = this.defaultPeriodType}

  /**
     * @description: Get the current account details.
     */
    private getCurrentAccountDetails(): void {
      this.sessionService
        .getSelectedAccount$()
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((account: IAccount) => {
          this.accountId = account?._id;
        });
    }
  
    /**
     * @description: Get the current user details.
     * @returns: void
     * @arguments: void
     */
    private getCurrentUserDetails(): void {
      this.sessionService
        .getCurrentUser$()
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((user) => {
          this.userId = user?.login?._id;
        });
    }

  ngOnInit(): void {
    this.initFilterData();
    this.initUserFetchData()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(([account, user]: [IAccount, any]) => {
        this.accountId = account?._id;
        this.userId = user?.login?._id;
        this.loadReviewsData();
      });
  }

  private initUserFetchData(): Observable<[IAccount, any]> {
    this.getCurrentAccountDetails();
    this.getCurrentUserDetails();

    return combineLatest([
      this.sessionService.getSelectedAccount$().pipe(rxFilter(Boolean), take(1)) as Observable<IAccount>,
      this.sessionService.getCurrentUser$().pipe(rxFilter(Boolean), take(1)),
    ]).pipe(takeUntil(this.ngUnsubscribe$)) as Observable<[IAccount, any]>;
  }
  

  private initFilterData(): void {
    this.filterData.push(
      /*{
        type: FILTER_TYPES.MULTI,
        title: 'RATINGS',
        options: ['5', '4', '3', '2', '1'],
      },*/
      {
        type: FILTER_TYPES.DATE,
        title: 'DATE',
        options: Object.values(PeriodText),
      },
      /*{
        type: FILTER_TYPES.SINGLE,
        title: 'REVIEW TEXT',
        options: ['Review includes text', 'Review does not include text'],
      }*/
    );
  }

  userSearch(): void {
    this.loadReviewsData();
  }

  onFilterChange(filters: IFitersObject): void {
    //Date implemented
    this.filters = filters;
    this.loadReviewsData();
  }

  hideOverview(toggle: boolean) {
    this.showOverview = !toggle;
  }

  AddFiltersToReviewData(filters = undefined) {

  const dateFilter = filters?.["DATE"]?.[0];
  
  if (!dateFilter) {
    this.periodType = PeriodType.DAY;
    return { timeunit: (PeriodType.DAY).toLowerCase(), periods: '30' };
  }
  //Custom date func, waiting for api implementation.
  /*const dateRangeRegex = /^\d{4}-\d{2}-\d{2} - \d{4}-\d{2}-\d{2}$/;
  if (dateRangeRegex.test(dateFilter)) {
    const [startStr, endStr] = dateFilter.split(' - ');
    const [sy, sm, sd] = startStr.split('-').map(Number);
    const [ey, em, ed] = endStr.split('-').map(Number);
    const startDate = new Date(sy, sm - 1, sd);
    const endDate = new Date(ey, em - 1, ed);
    const daysDiff = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));

    if (daysDiff > 60) {
      const monthsDiff = (endDate.getFullYear() - startDate.getFullYear()) * 12
        + (endDate.getMonth() - startDate.getMonth());
      this.periodType = PeriodType.MONTH;
      return { timeunit: (PeriodType.MONTH).toLowerCase(), periods: String(monthsDiff) };
    }

    this.periodType = PeriodType.DAY;
    return { timeunit: (PeriodType.DAY).toLowerCase(), periods: String(daysDiff) };
  }*/

  switch (dateFilter) {
    case PeriodText.THIS_MONTH: {
      const today = new Date();
      const daysPassedThisMonth = today.getDate();
      this.periodType = PeriodType.DAY;
      return { timeunit: (PeriodType.DAY).toLowerCase(), periods: String(daysPassedThisMonth-1) };
    }

    case PeriodText.LAST_30_DAYS: {
      this.periodType = PeriodType.DAY;
      return { timeunit: (PeriodType.DAY).toLowerCase(), periods: '30' };
    }

    case PeriodText.LAST_MONTH: {
      const today = new Date();
      const daysPassedThisMonth = today.getDate();
      this.periodType = PeriodType.DAY;
      return { timeunit: (PeriodType.DAY).toLowerCase(), periods: String(daysPassedThisMonth+31-1) };
    }

    case PeriodText.YEAR_TO_DATE: {
      const today = new Date();
      const startOfYear = new Date(today.getFullYear(), 0, 1);
      const daysPassedThisYear = Math.ceil((today.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24));

      if (daysPassedThisYear > 60) {
        const monthsPassed = today.getMonth(); 
        this.periodType = PeriodType.MONTH;
        return { timeunit: (PeriodType.MONTH).toLowerCase(), periods: String(monthsPassed+1) };
      }

      this.periodType = PeriodType.DAY;
      return { timeunit: (PeriodType.DAY).toLowerCase(), periods: String(daysPassedThisYear) };
    }

    case PeriodText.LAST_12_MONTHS: {
      this.periodType = PeriodType.MONTH;
      return { timeunit: (PeriodType.MONTH).toLowerCase(), periods: '12' };
    }

    default:
      return { timeunit: (PeriodType.DAY).toLowerCase(), periods: '30' };
  }
}

  loadReviewsData(): void {
    const {timeunit,periods} = this.AddFiltersToReviewData(this.filters);
    const config = {
      header: true,
    };
    forkJoin({
      metrics:this.getExportedReport(this.accountId, this.userId, 'reviews/account', timeunit, periods),
    }).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(({ metrics}) => {
          //Parsing reviews:
          const currDataReviews = this.convertCSVToJSONService
            .csvToJson(metrics, config)
            ['data'].filter((data) => Object.keys(data).length > 1);
          //Directories are considered search engines in this case, currently we are not supporting rows that do not contain "all"  
          //const directoryRows = currDataReviews.filter(row => row.directory !== 'ALL');
          let allRows = currDataReviews.filter(row => row.directory == 'ALL');
          //Edge case for last month since we have to filter through the records for the ones of last month only.
          if (this.filters?.["DATE"]?.[0] == PeriodText.LAST_MONTH) {
            const today = new Date();
            const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
            allRows = allRows.filter(row => {
              const [year, month, day] = row.period_start_date.split('-').map(Number);
              const date = new Date(year, month - 1, day);
              return date >= firstDayLastMonth && date <= lastDayLastMonth;
            });
          }
          const filteredRows = allRows;
          const { totalRatingsDaily, totalReviewsDaily, highStarsCount, medStarsCount, lowStarsCount, totalRepliedTo, avgRowRating, avgRowReviews } = filteredRows.reduce((prev, curr) => {
            return {
              totalRatingsDaily: prev.totalRatingsDaily + parseFloat(curr.Average_rating),
              totalReviewsDaily: prev.totalReviewsDaily + parseFloat(curr.Total_ratings),
              highStarsCount: prev.highStarsCount + parseFloat(curr.Total_positive_ratings),
              medStarsCount: prev.medStarsCount + parseFloat(curr.Total_neutral_ratings),
              lowStarsCount: prev.lowStarsCount + parseFloat(curr.Total_negative_ratings),
              totalRepliedTo: prev.totalRepliedTo + parseFloat(curr.response_count),
              avgRowRating: [...prev.avgRowRating, { date: curr.period_start_date, value: curr.Average_rating }],
              avgRowReviews: [...prev.avgRowReviews, { date: curr.period_start_date, value: curr.Total_ratings }],
            };
          }, { totalRatingsDaily: 0, totalReviewsDaily: 0, highStarsCount: 0, medStarsCount: 0, lowStarsCount: 0, totalRepliedTo:0, avgRowRating:[], avgRowReviews:[] });

          const reviewData: IReviewsMetrics = {            
              account: filteredRows[0]?.account_name,
              account_id: filteredRows[0]?.account_ident,
              dateStart: filteredRows[0]?.period_start_date,
              dateEnd: undefined,
              avgStarRating: (totalRatingsDaily/filteredRows.length),
              highStarsCount: highStarsCount,
              medStarsCount: medStarsCount,
              lowStarsCount: lowStarsCount,
              totalReviews: totalReviewsDaily,
              totalRepliedTo: totalRepliedTo,
              avgRatingsDaily: [],   
              totalReviewsDaily: [],             
          }      
          this.reviewsData = reviewData;          
          this.dailyAvgRatings = avgRowRating;
          this.dailyTotalReviews = avgRowReviews;
        },
        (err)=>{
          console.log(err);
        }
      );
    
  }
  //This function is duplicated as instructed due to the amount of repetitions of similar snippets in this project, 
  //it will be replaced in console 4.0
  public getExportedReport(
      accountId: any,
      userId: any,
      directoryName: string,
      timeunit: string,
      periods: any,
      filters?: string
    ): Observable<any> { 
      const payloadObj = {
        iss: 'https://platform.renderseo.com', 
        sub: userId, 
        account_id: accountId,
        iat: new Date().getTime(),
        exp: new Date().getTime() + 3 * 6000,
      };
      const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
      const options = {
        headers: new HttpHeaders({
          'content-type': 'application/json',
          Authorization: `${jwtToken}`,
        }),
        responseType: 'text' as any,
      };
  
      let url: string;
      url = `https://io.renderseo.com/${directoryName}?timeunit=${timeunit}&periods=${periods}`;
      return this.http.get(url, options);
    }

  /*private buildWhereClause(): Array<string> {
    const filterClauses: string[][] = [];
    const tempFilterArr: string[] = [];
    const isFiltersApplied = this.chipsArray.length > 0;

    const pushQueriesToMainArray = () => {
      const filterClause: Array<string> = ['-or', ...tempFilterArr];
      filterClauses.push(filterClause);
      tempFilterArr.length = 0;
    };

    if (isFiltersApplied) {
      for (const [key, value] of Object.entries(this.filters)) {
        if (value?.length > 0 && value[0] != null) {
          switch (key) {
            case 'TAGS':
              value.forEach((tag: string) => tempFilterArr.push(`tags @> '{"${tag}"}'`));
              pushQueriesToMainArray();
              break;
            case 'REVIEWS':
              value.forEach((element: string) => {
                element === 'Responded to'
                  ? tempFilterArr.push('NOT replyComment IS NULL')
                  : tempFilterArr.push('replyComment IS NULL');
              });
              pushQueriesToMainArray();
              break;
            case 'RATINGS':
              value.forEach((element: string) => {
                const rating = parseInt(element, 10);
                if (rating >= 1 && rating <= 5) {
                  tempFilterArr.push(`starRating = ${rating}`);
                }
              });
              pushQueriesToMainArray();
              break;
            case 'DATE':
              value.forEach((element: string) => {
                this.selectedDateRange = element;
                switch (element) {
                  case 'This month':
                    tempFilterArr.push(
                      `extract(month from r.date) = extract(month from current_date) and extract(year from r.date) = extract(year from current_date)`
                    );
                    break;
                  case 'Last 30 days':
                    tempFilterArr.push(`r.date > (now() - interval '30 day')`);
                    break;
                  case 'Last month':
                    tempFilterArr.push(
                      `extract(month from r.date) = extract(month from current_date) - 1 and extract(year from r.date) = extract(year from current_date)`
                    );
                    break;
                  case 'Year to date':
                    tempFilterArr.push(`extract(year from r.date) = extract(year from current_date)`);
                    break;
                  case 'Last 12 months':
                    tempFilterArr.push(`r.date > (now() - interval '12 month')`);
                    break;
                  case 'DefaultDate':
                    tempFilterArr.push(`r.date > (now() - interval '30 day')`);
                    break;
                  default:
                    const dateArray: string[] = element.split(' - ');
                    if (dateArray.length === 2) {
                      tempFilterArr.push(
                        `reviewCreatedAt >= '${dateArray[0]}' AND reviewCreatedAt <= '${dateArray[1]}'`
                      );
                    }
                    break;
                }
              });
              pushQueriesToMainArray();
              break;
            case 'REVIEW TEXT':
              value.forEach((element: string) => {
                element === 'Review includes text'
                  ? tempFilterArr.push('reviewercomment IS NOT NULL')
                  : tempFilterArr.push('reviewercomment IS NULL');
              });
              pushQueriesToMainArray();
              break;
          }
        }
      }
    } else {
      this.selectedDateRange = 'DefaultDate';
      tempFilterArr.push(`r.date > (now() - interval '30 day')`);
      pushQueriesToMainArray();
    }

    if (this.keyword) {
      tempFilterArr.push(`storeCode::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`businessName::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`tags::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`addressLines::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`city::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`state::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`postalCode::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`reviewerComment::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`replyComment::text ~* '\\y${this.keyword}'`);
      pushQueriesToMainArray();
    }

    const whereClauseArray: Array<any> = [
      '-and',
      "r._status IN ('A', 'UA', 'UP')",
      "vendorIdent='gmb'",
      ...filterClauses,
    ];
    return whereClauseArray;
  }*/

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}